import config from './config'
import GA from 'react-ga4'
import maps from './maps'
import { utils } from './utils'
export * from './maps/api/index'
export * from 'maplibre-gl'
export * from './common/interface'
export { NBMap, NBMapOptions } from './maps/map'
// Backward-compat alias: ResourceTypeEnum was renamed to ResourceType in maplibre-gl 5.x
export { ResourceType as ResourceTypeEnum } from 'maplibre-gl'
// StyleSpecification moved to @maplibre/maplibre-gl-style-spec in 5.x — re-export for consumers
export type { StyleSpecification } from '@maplibre/maplibre-gl-style-spec'
// export { DirectionsService } from './maps/api'
import packageJSON from '../package.json'
const version = packageJSON.version
export { utils } from './utils'

function GAInit() {
  GA.initialize('G-WJP85E58K8')

  GA.event({
    category: 'web_sdk2',
    action: 'web_sdk_loaded',
    label: '2.0',
  })
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    GAInit()
  } else {
    window && window.addEventListener('DOMContentLoaded', GAInit)
  }
}
/**
 * NextBillion.ai web SDK Entry.
 *
 * You need to use the singleton instance of this class by calling `window.nextbillion` if you load the sdk with CDN url.
 * Or you can get instance by `import nextbillion from '@nbai/nbmap-gl' if you import the sdk with npm`
 *
 */
export class NextBillion {
  maps = maps
  utils = utils

  get version(): string {
    return version
  }

  get apiKey(): string | null {
    return config.API_KEY
  }

  set apiKey(token: string | null) {
    config.API_KEY = token
  }

  /**
   * Set the API key for the web SDK.
   * @param {string} token
   */
  setApiKey(token: string | null): void {
    config.API_KEY = token
  }

  get apiKeyHeaderName(): string | null {
    return config.API_KEY_HEADER_NAME
  }

  set apiKeyHeaderName(name: string | null) {
    config.API_KEY_HEADER_NAME = name
  }

  setApiKeyHeaderName(name: string | null): void {
    config.API_KEY_HEADER_NAME = name
  }

  get apiHost(): string | null {
    return config.API_HOST
  }

  set apiHost(host: string | null) {
    config.API_HOST = host
  }

  /**
   * Set the API host for the web SDK.
   * @param {string} host
   */
  setApiHost(host: string | null): void {
    config.API_HOST = host
  }

  /**
   * Enable the inner request transform for NextBillion.ai maptiles.
   */
  EnableNBTransform(): void {
    config.DISABLE_NB_TRANSFORM = false
  }

  /**
   * Disable the inner request transform for NextBillion.ai maptiles. You only need to call this method if you want to use the maptiles not provided by nextbillion.ai.
   */
  DisableNBTransform(): void {
    config.DISABLE_NB_TRANSFORM = true
  }
}

const nextbillion = new NextBillion()

export default nextbillion
